"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _mobx = require("mobx");
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
var _class;
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var WordTypeStore = (_class = /*#__PURE__*/function (_RootStore) {
  function WordTypeStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, WordTypeStore);
    _this = _callSuper(this, WordTypeStore);
    _this.config = {
      model: _models.WordType,
      deserialize: true,
      GET: {
        index: '/word_types',
        show: '/word_types/:wordTypeId'
      },
      POST: {
        create: '/word_types',
        toggleLanguage: '/word_types/:wordTypeId/toggle_language/:languageId'
      },
      PUT: {
        update: '/word_types/:wordTypeId'
      },
      DELETE: {
        destroy: '/word_types/:wordTypeId'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(WordTypeStore, _RootStore);
  return (0, _createClass2["default"])(WordTypeStore, [{
    key: "byName",
    value: function byName(name) {
      return this.indexData.find(function (item) {
        return item.name === name;
      });
    }
  }, {
    key: "toggleLanguage",
    value: function toggleLanguage(params, callback) {
      this.api(params, callback, 'POST', 'toggleLanguage');
    }
  }, {
    key: "rootWordTypes",
    get: function get() {
      return this.indexData.filter(function (item) {
        return item.root;
      });
    }
  }, {
    key: "allForSelect",
    get: function get() {
      return this.indexData.map(function (item) {
        return [item.id, item.name];
      });
    }
  }, {
    key: "noun",
    get: function get() {
      return this.indexData.find(function (item) {
        return item.abbreviation === 'noun';
      });
    }
  }]);
}(_root_store["default"]), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "rootWordTypes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "rootWordTypes"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "allForSelect", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "allForSelect"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "noun", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "noun"), _class.prototype), _class);
var _default = exports["default"] = new WordTypeStore();